import { useEffect } from "react";
import { RenderCheckboxProps } from "../../../../types";
import { customEvaluations, processDependenyRules } from "../../evaluations";
import {
  SwitchWithTooltip,
} from "../../../common/Tooltip";

export default function RenderCheckbox({
  title,
  description,
  propertyKey,
  propertySubKey,
  rowIndex,
  inputValue,
  isDisabled,
  isDialogField,
  dependencyRules,
  triggerDependencyRule,
  evalMethod,
  selectedTabSectionKey,
  rowDataReducerState,
  dispatch,
}: Readonly<RenderCheckboxProps>): JSX.Element {
  let id = "";
  if (rowIndex !== undefined && propertySubKey) {
    id = `-${rowIndex}-${propertySubKey}`;
  } else if (propertySubKey) {
    id = `-${propertySubKey}`;
  }
  const formattedId = `${propertyKey}${id}-switch-input`;

  const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({
      type: "UPDATE_FIELD",
      payload: {
        propertyKey,
        newFieldValue: event.target.checked,
        rowIndex,
        propertySubKey,
        selectedTabSectionKey,
        isDialogField,
      },
    });

    if (evalMethod) {
      customEvaluations({
        evalMethod,
        propertyKey,
        propertySubKey,
        rowIndex,
        inputValue: event.target.checked,
        searchResponse: undefined,
        selectedTabSectionKey,
        rowDataReducerState,
        dispatch,
      });
    }
  };

  useEffect(() => {
    // No need to process dependency rules for dialog fields
    if (dependencyRules && !isDialogField) {
      processDependenyRules({
        dependencyRules,
        propertyKey,
        inputValue: Boolean(inputValue),
        propertySubKey,
        rowIndex,
        selectedTabSectionKey,
        rowDataReducerState,
        dispatch,
      });
    }
  }, [inputValue, triggerDependencyRule]);

  useEffect(() => {
    const EXCLUDED_EVAL_METHODS_ON_MOUNT = [
      "handlePOConfigurationGroupShippingInfoDefaultAddress",
    ];

    if (evalMethod && !EXCLUDED_EVAL_METHODS_ON_MOUNT.includes(evalMethod)) {
      customEvaluations({
        evalMethod,
        propertyKey,
        propertySubKey,
        rowIndex,
        inputValue: Boolean(inputValue),
        searchResponse: undefined,
        selectedTabSectionKey,
        rowDataReducerState,
        dispatch,
      });
    }
  }, []);

  return (
    <SwitchWithTooltip
      dataTestId={formattedId}
      id={formattedId}
      label={title}
      checked={Boolean(inputValue)}
      labelPosition="AFTER"
      name={propertyKey}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
        handleInput(event)
      }
      size="standard"
      isDisabled={isDisabled}
      tooltip={description}
    />
  );
}
